import unidadeRouters from '@/modules/estoque/unidade/router';
import cestRouters from '@/modules/estoque/cest/router';
import produtoRouters from '@/modules/estoque/produto/router';
import sobreRouters from '@/modules/configuracoes/version/router';
import cliForRouters from '@/modules/crm/pessoa/router';
import marcaRouters from '@/modules/estoque/marca/router';
import saidaRouters from '@/modules/comercial/saidas/router';
import configurarRouters from '@/modules/configuracoes/configuracao/router';
import filialRouters from '@/modules/configuracoes/filial/router';
import classeRouters from '@/modules/estoque/classe/router';
import subClasseRouters from '@/modules/estoque/subclasse/router';
import familiaRouters from '@/modules/estoque/familia/router';
import grupoRouters from '@/modules/estoque/grupo/router';
import { createRouter, createWebHistory } from 'vue-router';
import vendaPerdidaRouters from '@/modules/comercial/vendaPerdida/router';
import motivoVendaPerdidaRouters from '@/modules/comercial/motivoVendaPerdida/router';

const baseRoutes = [
  {
    path: '/',
    name: 'home',
    title: 'Home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/error/',
    name: 'error',
    component: () => import('../views/ErrorView.vue'),
    meta: {
      layout: 'EmptyLayout',
    },
  },
  {
    path: '/filial/selecionar',
    name: 'FilialSelecionar',
    component: () => import('@/modules/configuracoes/filial/views/FilialSelecionarView.vue'),
    meta: {
      layout: 'EmptyLayout',
    },
  },
];

const modulesRoute = [...cestRouters, ...unidadeRouters, ...produtoRouters, ...sobreRouters, ...cliForRouters, ...marcaRouters, ...saidaRouters, ...configurarRouters, ...filialRouters, ...classeRouters, ...subClasseRouters, ...familiaRouters, ...grupoRouters, ...vendaPerdidaRouters, ...motivoVendaPerdidaRouters];
const routes = baseRoutes.concat(modulesRoute);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title || to.name} - ${process.env.VUE_APP_TITLE}`;
  next();
});

export default router;
